const config = {
    apiUrl: "https://api.assetslices.com",
    uiUrl : "http://174.129.169.135",
    featureFlag: true
  };

  export default config;